import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Modal, Select, Tooltip } from 'components';
import { CleanIcon, AddIcon, DeleteIcon } from 'assets/icons';
import { Globals } from 'utils';
import { NotificationService } from 'services';
import ModalCreate from './modal-create';
import moment from 'moment';

interface Props extends RouteComponentProps {
	dispatch: any;
}

const INITIAL_STATE = {
	level_id: '',
	since: '',
	until: '',
};

class Notifications extends React.Component<Props> {
	state = {
		data: [] as any[],
		page: 1,
		last_page: 1,
		header: ['Fecha de envío', 'Tipo de cliente', 'Mensaje', 'Acciones'],
		form: INITIAL_STATE,
		createVisible: false,
		viewVisible: false,
		currentItem: null as any,
	};

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Notificaciones',
				onBack: null,
			},
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: '',
			},
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await NotificationService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since ? moment(this.state.form.since).format('YYYY-MM-DD') : '',
			until: this.state.form.until ? moment(this.state.form.until).format('YYYY-MM-DD') : '',
		});

		this.setState({
			data: res.notifications?.rows || [],
			last_page: res.notifications?.count || 1,
		});
	};

	reset = () => {
		this.setState(
			{
				form: INITIAL_STATE,
				page: 1,
			},
			() => this.load(true),
		);
	};

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value,
			},
		});
	};

	changeDate = (field: string, value: any) => {
		const dateValue = value && value.target ? value.target.value : value;
		this.setState({
			form: {
				...this.state.form,
				[field]: dateValue,
			},
		});
	};

	applyFilters = () => {
		this.setState(
			{
				page: 1,
			},
			() => this.load(true),
		);
	};

	openCreate = () => {
		this.setState({
			createVisible: true,
			currentItem: null,
		});
	};

	closeCreate = () => {
		this.setState({
			createVisible: false,
			currentItem: null,
		});
	};

	handleCreateSubmit = async (form: any) => {
		await NotificationService.admin.create(form);
		Globals.showSuccess('Se ha creado la notificación correctamente');
		this.setState(
			{
				createVisible: false,
			},
			() => this.load(true),
		);
	};

	openView = (item: any) => {
		this.setState({
			currentItem: item,
			viewVisible: true,
		});
	};

	closeView = () => {
		this.setState({
			currentItem: null,
			viewVisible: false,
		});
	};

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la notificación?', async () => {
			await NotificationService.admin.delete({
				id: item.id,
			});
			this.load(true);
		});
	};

	renderViewModal() {
		const { currentItem } = this.state;

		if (!currentItem) return null;

		return (
			<div id="modal-view-notification">
				<h3>Mensaje</h3>

				<div className="row header-row">
					<div className="col-md-6">
						<p className="label">Tipo de clientes</p>
						<p className="value">{currentItem.levels_names}</p>
					</div>
					<div className="col-md-6 text-right">
						<p className="label">Fecha</p>
						<p className="value date">
							{currentItem.date_es}
						</p>
					</div>
				</div>

				<div className="row message-row">
					<div className="col-md-12">
						<p className="label">Mensaje</p>
						<p className="message-text">{currentItem.message}</p>
					</div>
				</div>

				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" onClick={this.closeView}>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		);
	}

	render() {
		const { createVisible, viewVisible } = this.state;

		return (
			<div id="admin-notifications">
				{/* Modal crear notificación */}
				<Modal
					className="modal-create-notification"
					visible={createVisible}
					withoutClose={true}
					onClose={this.closeCreate}
				>
					<ModalCreate onClose={this.closeCreate} onSubmit={this.handleCreateSubmit} />
				</Modal>

				{/* Modal ver notificación */}
				<Modal
					className="modal-view-notification"
					visible={viewVisible}
					withoutClose={true}
					onClose={this.closeView}
				>
					{this.renderViewModal()}
				</Modal>

				{/* Filtros */}
				<div className="row row-filter">
					<div className="col-md-3">
						<Select
							label="Tipo de cliente"
							name="level_id"
							onChange={this.change}
							value={this.state.form.level_id}
							options={[
								{ value: '', label: 'Seleccione' },
								{ value: '5', label: 'Usuario' },
								{ value: '4', label: 'Afiliado' },
								{ value: '3', label: 'Vendedor' },
							]}
						/>
					</div>
					<div className="col-md-3">
						<DatePicker
							label="Desde"
							name="since"
							value={this.state.form.since}
							onChange={(value: any) => this.changeDate('since', value)}
						/>
					</div>
					<div className="col-md-3">
						<DatePicker
							label="Hasta"
							name="until"
							value={this.state.form.until}
							onChange={(value: any) => this.changeDate('until', value)}
						/>
					</div>
					<div className="col-md-3 filter-actions">
						<Button className="btn-filter" onClick={this.applyFilters}>
							Filtrar
						</Button>

						{this.state.form !== INITIAL_STATE && (
							<Button className="btn-clean" onClick={this.reset}>
								Limpiar
							</Button>
						)}
					</div>
				</div>

				{/* Tabla */}
				<Table
					title="Notificaciones Registradas"
					data={this.state.data.length}
					rightAlign={[3]}
					header={this.state.header}
					titleRight={
						<Button className="btn-add-notification" onClick={this.openCreate}>
							<img src={AddIcon} alt="Nueva notificación" />
							Nueva notificación
						</Button>
					}
				>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{i.date_es}</td>
								<td>{i.levels_names}</td>
								<td className="message-link-cell">
									<button
										type="button"
										className="btn-link view-link"
										onClick={() => this.openView(i)}
									>
										Ver
									</button>
								</td>
								<td className="text-right">
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
											<img src={DeleteIcon} alt="Eliminar" />
										</a>
									</Tooltip>
								</td>
							</tr>
						);
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page,
						});
						this.load();
					}}
				/>
			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {};
})(Notifications);
